import React from 'react';
import "../css/Header.css";
import { Icon } from 'semantic-ui-react'



const Header = () => {
    return (
        <div className="header ">
            <h2>WarszaWa</h2>
            <div className="">   
            <a href="https://www.instagram.com/warszawabandofficial/" ><Icon className="inverted white" name="instagram" size="big"></Icon></a>
            <a href="https://vk.com/warszawaband"><Icon className="inverted white" name="vk" size="big"></Icon> </a>
            <a ><Icon className="inverted white" name="facebook"size="big"></Icon></a>
            <a href="https://open.spotify.com/artist/2spMwglZ0VRf2JXI5PvMqW"><Icon className="inverted white" name="spotify" size="big"></Icon></a>
            </div>
            
            
        </div>
    )
}

export default Header
